export const SUGGESTION_COLORS = {
  default: {
    focused: 'var(--mantine-color-brand-0)',
    unfocused: 'var(--mantine-color-brand-1)',
  },
  note: {
    focused: 'var(--mantine-color-blue-0)',
    unfocused: 'var(--mantine-color-blue-1)',
  },
  inline: {
    focused: 'var(--mantine-color-brand-0)',
    unfocused: 'var(--mantine-color-brand-1)',
  },
  placeholder: {
    focused: 'var(--mantine-color-orange-1)',
    unfocused: 'var(--mantine-color-orange-2)',
  },
  deletion: {
    focused: 'var(--mantine-color-brand-0)',
    unfocused: 'var(--mantine-color-brand-1)',
  },
} as const;
